import type { TFunction } from 'i18next';
import type { U2000DeleteHandlersReturn } from '../../../u2000Core/hooks/handler/U2000UseDeleteHandlers';
import U2000DeleteRecordDialog from '../../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import type { U3202OrgProviderConfigSearchRow } from '../../U3202Service';

interface U3202OrgProviderConfigDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn<U3202OrgProviderConfigSearchRow>;
  t: TFunction;
  NS: string;
}

function U3202OrgProviderConfigDeleteDlg({ handleDelete, t, NS }: U3202OrgProviderConfigDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  const rows = handleDelete.selectedRows();
  const count = rows.length;

  return (
    <U2000DeleteRecordDialog
      isOpen={handleDelete.isDialogDeleteOpen}
      onClose={handleDelete.handleDeleteCloseDlg}
      title={t('lblDeleteDlgTitle', { ns: NS, defaultValue: 'Confirmation de suppression' })}
    >
      <p className="mb-4">
        {t(count === 1 ? 'delete.confirm' : 'delete.confirm_other', {
          count,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {rows.map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.name ?? row.id} (${row.code ?? ''})`}
            {index < array.length - 1 && ', '}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3202OrgProviderConfigDeleteDlg;
